import React, { useState } from 'react';
import { Progress, Button } from 'antd';
import { CloseOutlined, CheckCircleOutlined, CloseCircleOutlined, LoadingOutlined, UpOutlined, DownOutlined } from '@ant-design/icons';
import './NotificationToast.css';

const NotificationToast = ({ notification, onDismiss, onRemove }) => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const isProcessing = notification.status === 'processing' || notification.status === 'pending';

  const getStatusIcon = () => {
    switch (notification.status) {
      case 'completed':
        return <CheckCircleOutlined className="notification-icon notification-icon-success" />;
      case 'error':
        return <CloseCircleOutlined className="notification-icon notification-icon-error" />;
      case 'processing':
        return <LoadingOutlined className="notification-icon notification-icon-processing" spin />;
      default:
        return <LoadingOutlined className="notification-icon notification-icon-pending" spin />;
    }
  };

  const getStatusColor = () => {
    switch (notification.status) {
      case 'completed':
        return 'var(--color-success)';
      case 'error':
        return 'var(--color-error)';
      case 'processing':
        return 'var(--color-primary)';
      default:
        return 'var(--color-text-muted)';
    }
  };

  return (
    <div className={`notification-toast notification-toast-${notification.status} ${isCollapsed ? 'notification-toast-collapsed' : ''}`}>
      <div className="notification-content">
        <div className="notification-header">
          <div className="notification-icon-wrapper">
            {getStatusIcon()}
          </div>
          <div className="notification-text">
            <div className="notification-title">
              {isCollapsed && notification.title.length > 32
                ? `${notification.title.substring(0, 32)}...`
                : notification.title}
            </div>
            {!isCollapsed && notification.message && (
              <div className="notification-message">{notification.message}</div>
            )}
          </div>
          <div className="notification-actions">
            {isProcessing && (
              <Button
                type="text"
                size="small"
                icon={isCollapsed ? <DownOutlined /> : <UpOutlined />}
                onClick={() => setIsCollapsed(!isCollapsed)}
                className="notification-collapse-btn"
                title={isCollapsed ? 'Expand' : 'Collapse'}
              />
            )}
          {notification.dismissible && (
            <Button
              type="text"
              size="small"
              icon={<CloseOutlined />}
              onClick={() => {
                // For completed notifications, dismiss (keep in history)
                // For other statuses, remove completely
                if (notification.status === 'completed' || notification.status === 'error') {
                  onDismiss(notification.id);
                } else {
                  onRemove(notification.id);
                }
              }}
              className="notification-close-btn"
            />
          )}
          </div>
        </div>
        {!isCollapsed && notification.progress !== null && notification.progress !== undefined && (
          <div className="notification-progress">
            <Progress
              percent={notification.progress}
              strokeColor={getStatusColor()}
              showInfo={false}
              size="small"
            />
            <div className="notification-progress-text">
              {notification.progress}%
            </div>
          </div>
        )}
      </div>
      {/* Bottom progress bar when collapsed */}
      {isCollapsed && notification.progress !== null && notification.progress !== undefined && isProcessing && (
        <div className="notification-bottom-progress">
          <Progress
            percent={notification.progress}
            strokeColor={getStatusColor()}
            showInfo={false}
            size="small"
            strokeWidth={4}
          />
        </div>
      )}
    </div>
  );
};

export default NotificationToast;
